export const APP_LOADED = 'APP_LOADED';
export const SET_LOGGED_USER = 'SET_LOGGED_USER';
export const SHOW_ERROR = 'SHOW_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const LOAD_LANGUAGES_REQUEST = 'LOAD_LANGUAGES_REQUEST';
export const LOAD_LANGUAGES_SUCCESS = 'LOAD_LANGUAGES_SUCCESS';
export const APP_CHANGE_LANGUAGE = 'CHANGE_LANGUAGE_REQUEST';
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const DISABLE_CREATOR = 'DISABLE_CREATOR';